import React from 'react';
import { Typography } from 'antd';

const { Title, Paragraph } = Typography;

export default PrivacyPolicyBackupNinja;

/**
 * Source: https://docs.google.com/document/d/1JuH_n45GcNMKX6EzBCXozCnZeoFlk8BbqVb0pg2hTO4/edit#heading=h.xwj84y1tfsvb
 * @name PrivacyPolicyBackupNinja
 * @desc PrivacyPolicyBackupNinja component.
 */
function PrivacyPolicyBackupNinja() {
    return (
        <div className="PrivacyPolicyBackupNinja">
            <Title>Backup Ninja Privacy Policy</Title>
            <Paragraph>
                Severalnines AB (“Company”) is committed to protecting your
                privacy. This Data Privacy Policy tells you about our policy and
                practice for the collection, use, processing, storage, transfer,
                protection, and disclosure of information that we may collect
                about you through our website, backup.ninja, or any subdomains,
                marketing events, or our partners.
            </Paragraph>
            <Paragraph>
                Before you access and use our websites or submit your personal
                information to us, you will be asked to provide your
                authorization and consent by agreeing to the “{' '}
                <a
                    href="terms-and-conditions?origin=exoscale"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Terms of Service
                </a>
                ” and this Backup Ninja Data Privacy Policy and consenting to
                the collection, your submission (if applicable), and processing
                of information about you as described herein, in compliance with
                relevant data protection laws.
            </Paragraph>
            <Paragraph>
                The collection, use, processing, storage, transfer and
                disclosure of your Personal Information (as defined below) will
                be limited to the terms under which you provide Severalnines
                your authorization. We are committed to compliance with all
                relevant country-specific data privacy laws, including EU
                Standard Contractual Clauses, model contracts / transfer
                agreements, privacy statements and policies, and
                country-specific filings if applicable.
            </Paragraph>

            <Title level={3}>Collected Data</Title>
            <Paragraph>
                Personal Information is data that can be used to identify,
                either directly or indirectly, an individual to whom the
                information applies. The information that we may collect from
                you includes your name, email address, contact preferences,
                login information (account number, password), marketing
                preferences, and as applicable, IP address.
            </Paragraph>
            <Paragraph>
                Furthermore, the Company may also collect anonymized statistics
                about the way the User uses the Services provided by the
                Company.
            </Paragraph>

            <Title level={3}>Purpose of Data Collection</Title>
            <Paragraph>
                The primary purpose of collecting personal data is to provide
                Services to the User and to issue accurate charges for the use
                of Services.
            </Paragraph>
            <Paragraph>
                The personal data stored in the User Register may also be used
                by the Company to provide, develop and customize the Service and
                to communicate with the User. Such communication may include
                direct marketing, market research or research polls. The Company
                may use subcontractors when providing any services.
            </Paragraph>

            <Title level={3}>
                Legal Basis for Processing Personal Data (European Territory
                Users only)
            </Title>
            <Paragraph>
                The Company provides the representations and information in this
                section in compliance with European privacy laws, in particular
                the European General Data Protection Regulation (GDPR). They are
                specific to Users located in EEA countries or Switzerland, so
                please don’t rely on the below, if you’re not a User in one of
                those countries.
            </Paragraph>
            <Paragraph>
                If you are a User from the European Territories, the Company’s
                legal basis for collecting and using the personal data described
                above will depend on the personal information concerned and the
                specific context in which it is collected. “European
                Territories” mean the European Economic Area and Switzerland.
            </Paragraph>
            <Paragraph>
                However, the Company will normally collect personal data from
                Users where the processing is in the Company’s legitimate
                business interests to, for example, administer Services and
                fulfill contractual obligations as a service provider. In some
                cases the Company may collect and process personal data based on
                consent.
            </Paragraph>

            <Title level={3}>Personal Data Communicated to Third Parties</Title>
            <Paragraph>
                {' '}
                The Company may communicate the Users’ personal data to its
                affiliates, cooperation partners or other third parties only to
                the extent as may be required and permitted by applicable laws,
                required for the purpose of providing the Service or defending
                the Company’s legitimate interests in accordance with the
                applicable law or required due to an acquisition or other
                corporate transaction.
            </Paragraph>
            <Paragraph>
                There are times when Severalnines may be required to disclose
                your Personal Information by law, legal process, litigation,
                and/or requests from public and governmental authorities.
                Severalnines may also disclose your Personal Information for
                purposes of investigations of threats to national security,
                compliance with requests from law enforcement, or other issues
                of public importance, or when we determine that disclosure is
                reasonably necessary to enforce our terms and conditions or
                protect our operations or users.
            </Paragraph>

            <Title level={4}>CRM Provider/s</Title>
            <Paragraph>
                The Company provides user data, as required, to the Company’s
                CRM provider/s. These provides include, but may not be limited
                to, Salesforce (Lead Management), Pardot (Email Marketing), &
                Stripe (Payment Processing)
            </Paragraph>

            <Title level={4}>Google Analytics</Title>
            <Paragraph>
                The Company uses Google Analytics, a service which transmits
                anonymous website traffic data to Google servers. The Company
                uses reports provided by Google Analytics to help the Company
                understand website traffic and usage.
            </Paragraph>
            <Paragraph>
                The Company also uses Google Analytics to send and receive data
                to/from Google Ads to improve the performance of the Company’s
                Google Ads campaigns and develop remarketing lists.
            </Paragraph>
            <Paragraph>
                User-level and event-level is automatically deleted from Google
                Analytics servers after 38 months. However, the 38 month period
                will reset if Google Analytics detects new activity, such as a
                site visit.
            </Paragraph>

            <Title level={4}>Urchin Tracking Module (UTM) Tags</Title>
            <Paragraph>
                UTM tags are appended as part of the visible URL for marketing
                campaigns and reports can be viewed in platforms like Google
                Analytics. The Company sends UTM tag information to Google
                Google Analytics/Intercom to evaluate campaign performance.
            </Paragraph>
            <Paragraph>
                For example, if a user visits the website via a link with UTM
                parameters attached. These details, such as campaign source,
                medium, and name, are collected at an aggregated level and sent
                to Google Analytics.
            </Paragraph>
            <Paragraph>
                Moreover, if a user who clicks a campaign link with a UTM tag
                becomes a registered user, the UTM information will associated
                with the registration and sent to Intercom. This information
                helps the Company assess the utility of its marketing channels.
            </Paragraph>

            <Title level={3}>Quality of Data</Title>
            <Paragraph>
                To the extent required by the applicable law, the Company
                corrects, erases or supplements at the request of a User,
                possibly erroneous, unnecessary, incomplete or obsolete data
                processed in the User Register. However, Users are responsible
                for the validity and quality of the personal data they provide
                to the Company.
            </Paragraph>
            <Paragraph>
                A User also is responsible for notifying the Company of any
                possible changes in the personal data he/she has provided. In
                order to correct any possibly erroneous data, the Company
                recommends the User to contact the Company by using the contact
                information provided in this Privacy Policy.
            </Paragraph>

            <Title level={3}>Data Security</Title>
            <Paragraph>
                The Company has carried out reasonable technical and
                organizational measures to secure the personal data processed in
                the User Register against unauthorized access, against
                accidental or unlawful destruction, manipulation, disclosure and
                transfer and against other unlawful processing. For instance,
                access to automatically processed data is limited by user rights
                and passwords within the Company’s organization.
            </Paragraph>

            <Title level={3}>Cookies</Title>
            <Paragraph>
                Cookies are files which are received and transmitted by a User’s
                device when the User is using the Company’s Service. The Company
                uses cookies and similar techniques to provide the Service, to
                improve its quality and to enhance the user experience.
            </Paragraph>
            <Paragraph>
                The Company may also use cookies and similar techniques to track
                the User’s behavior on its marketing site to improve the site’s
                performance and user experience, as well as for ad campaign
                tracking, targeting and attribution. By using the Site and
                Services you consent to the use of cookies. User’s may block
                them in the User’s browser settings.
            </Paragraph>
            <Paragraph>
                Information collected by cookies and similar technologies are
                treated as non-personal information except to the extent under
                local law that IP addresses (or like identifiers) are otherwise
                considered Personal Information.
            </Paragraph>

            <Title level={3}>Users’ Rights</Title>
            <Paragraph>
                A User has the right to prohibit the Company from processing
                personal data stored on him/her in the User Register for the
                purposes of direct advertising, distance selling, other direct
                marketing, market research and opinion polls. In order to
                prohibit such processing, the Company recommends the User to
                contact us at dataprotection@severalnines.com to request
                addition to our suppression lists or by unsubscribing to a
                recently received email.
            </Paragraph>
            <Paragraph>
                A User also has the right to access the data stored on him/her
                in the User Register and upon request obtain a copy of the data.
                In order to access the data, the User shall provide sufficient
                search criteria and submit a request to the Company by emailing
                dataprotection@severalnines.com.
            </Paragraph>

            <Title level={4}>Children’s Privacy</Title>
            <Paragraph>
                Severalnines will not knowingly collect Personal Information
                from any person that is not a legal adult, as defined by local
                law, without insisting that they seek prior parental consent, if
                such consent is required by applicable law. Severalnines does
                not target children in connection with its products, services,
                and websites.
            </Paragraph>

            <Title level={4}>
                Additional Data Protection Rights for European Territory Users
            </Title>
            <Paragraph>
                If you are a resident of a European Territory, you have the
                right to complain to a data protection authority about our
                collection and use of your personal information. For more
                information, please contact your local data protection
                authority.
            </Paragraph>
            <Paragraph>
                Similarly, if the Company has collected and processed your
                personal information with your consent, then you can withdraw
                your consent at any time. Withdrawing your consent will not
                affect the lawfulness of any processing the Company conducted
                prior to your withdrawal, nor will it affect the processing of
                your personal information conducted in reliance on lawful
                processing grounds other than consent.
            </Paragraph>
            <Paragraph>
                If you wish to access, correct, update or request deletion of
                your personal information, you can contact us at
                dataprotection@severalnines.com.
            </Paragraph>

            <Title level={3}>Links to Other Websites</Title>
            <Paragraph>
                Our Site may contain links to other websites that are not
                operated by us. If you click on a third party link, you will be
                directed to that third party’s website. It is important that you
                review the Privacy Policy of every site you visit. We have no
                control over, and are unable to assume any responsibility for,
                the content, privacy policies or practices of any third party
                sites or services.
            </Paragraph>

            <Title level={3}>Product Feedback</Title>
            <Paragraph>
                If you provide feedback on any of our Products or our website,
                we may use such feedback for any purpose, provided we will not
                associate such feedback with your Personal Data. We will collect
                any information contained in such communication and will treat
                the Personal Data in such communication in accordance with this
                Privacy Policy.
            </Paragraph>

            <Title level={3}>Changes to the Privacy Policy</Title>
            <Paragraph>
                The Company may amend this Privacy Policy and the related
                information. The Company recommends that the Users regularly
                access the Privacy Policy to obtain knowledge of any possible
                changes made thereto. The Company aims at informing the Users of
                possible changes by using reasonable and available channels.
                This policy was last updated on October 10, 2019.
            </Paragraph>
        </div>
    );
}
